// iPhone, iPod, iPad, and iPadOS (which reports a Mac desktop UA).
export function isIosTextEntry(): boolean {
	if (typeof navigator === 'undefined') return false
	const ua = navigator.userAgent || ''
	if (/iPad|iPhone|iPod/.test(ua)) return true
	return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
}
